program EWA;

{$R *.dres}

uses
  WEBLib.Forms,
  Unit3 in 'd:\Users\Administrator\Documents\Embarcadero\Studio\Projects\Unit3.pas'{*.html},
  AddressType in 'Rest\Types\AddressType.pas',
  BaseListType in 'Rest\Types\BaseListType.pas',
  BaseType in 'Rest\Types\BaseType.pas',
  CategoryItemListType in 'Rest\Types\CategoryItemListType.pas',
  CategoryItemType in 'Rest\Types\CategoryItemType.pas',
  CategoryListType in 'Rest\Types\CategoryListType.pas',
  CategoryType in 'Rest\Types\CategoryType.pas',
  ChargeItemListType in 'Rest\Types\ChargeItemListType.pas',
  ChargeItemType in 'Rest\Types\ChargeItemType.pas',
  ChargeListScreenType in 'Rest\Types\ChargeListScreenType.pas',
  DepartmentItemListType in 'Rest\Types\DepartmentItemListType.pas',
  DepartmentItemType in 'Rest\Types\DepartmentItemType.pas',
  DepartmentListType in 'Rest\Types\DepartmentListType.pas',
  DepartmentType in 'Rest\Types\DepartmentType.pas',
  DeviceItemListType in 'Rest\Types\DeviceItemListType.pas',
  DeviceItemType in 'Rest\Types\DeviceItemType.pas',
  DeviceListType in 'Rest\Types\DeviceListType.pas',
  DeviceType in 'Rest\Types\DeviceType.pas',
  DisposableItemListType in 'Rest\Types\DisposableItemListType.pas',
  DisposableItemType in 'Rest\Types\DisposableItemType.pas',
  DisposableListScreenType in 'Rest\Types\DisposableListScreenType.pas',
  ErrorListType in 'Rest\Types\ErrorListType.pas',
  ErrorType in 'Rest\Types\ErrorType.pas',
  FileType in 'Rest\Types\FileType.pas',
  FunctionItemListType in 'Rest\Types\FunctionItemListType.pas',
  FunctionItemType in 'Rest\Types\FunctionItemType.pas',
  FunctionType in 'Rest\Types\FunctionType.pas',
  InstrumentItemListType in 'Rest\Types\InstrumentItemListType.pas',
  InstrumentItemType in 'Rest\Types\InstrumentItemType.pas',
  InstrumentListScreenType in 'Rest\Types\InstrumentListScreenType.pas',
  InstrumentScreenType in 'Rest\Types\InstrumentScreenType.pas',
  InstrumentType in 'Rest\Types\InstrumentType.pas',
  LocationItemType in 'Rest\Types\LocationItemType.pas',
  LocationType in 'Rest\Types\LocationType.pas',
  LoginType in 'Rest\Types\LoginType.pas',
  MedicineItemListType in 'Rest\Types\MedicineItemListType.pas',
  MedicineItemType in 'Rest\Types\MedicineItemType.pas',
  NetInstrumentItemListType in 'Rest\Types\NetInstrumentItemListType.pas',
  NetInstrumentItemType in 'Rest\Types\NetInstrumentItemType.pas',
  NetInstrumentListType in 'Rest\Types\NetInstrumentListType.pas',
  NetInstrumentType in 'Rest\Types\NetInstrumentType.pas',
  NetItemListType in 'Rest\Types\NetItemListType.pas',
  NetItemType in 'Rest\Types\NetItemType.pas',
  NetListScreenType in 'Rest\Types\NetListScreenType.pas',
  NetListType in 'Rest\Types\NetListType.pas',
  NetNumberItemListType in 'Rest\Types\NetNumberItemListType.pas',
  NetNumberItemType in 'Rest\Types\NetNumberItemType.pas',
  NetNumberStatusItemType in 'Rest\Types\NetNumberStatusItemType.pas',
  NetNumberStatusListType in 'Rest\Types\NetNumberStatusListType.pas',
  NetNumberStatusSetType in 'Rest\Types\NetNumberStatusSetType.pas',
  NetNumberStatusType in 'Rest\Types\NetNumberStatusType.pas',
  NetNumberType in 'Rest\Types\NetNumberType.pas',
  NetScreenType in 'Rest\Types\NetScreenType.pas',
  NetStatusListType in 'Rest\Types\NetStatusListType.pas',
  NetStatusType in 'Rest\Types\NetStatusType.pas',
  NetType in 'Rest\Types\NetType.pas',
  OperationType in 'Rest\Types\OperationType.pas',
  PersonalDataListType in 'Rest\Types\PersonalDataListType.pas',
  PersonalDataType in 'Rest\Types\PersonalDataType.pas',
  PrepareNetNumberListType in 'Rest\Types\PrepareNetNumberListType.pas',
  PrepareNetNumberType in 'Rest\Types\PrepareNetNumberType.pas',
  PrepareOperationDisposableItemListType in 'Rest\Types\PrepareOperationDisposableItemListType.pas',
  PrepareOperationDisposableItemType in 'Rest\Types\PrepareOperationDisposableItemType.pas',
  PrepareOperationItemListType in 'Rest\Types\PrepareOperationItemListType.pas',
  PrepareOperationItemType in 'Rest\Types\PrepareOperationItemType.pas',
  PrepareOperationListScreenType in 'Rest\Types\PrepareOperationListScreenType.pas',
  PrepareOperationMedicineItemListType in 'Rest\Types\PrepareOperationMedicineItemListType.pas',
  PrepareOperationMedicineItemType in 'Rest\Types\PrepareOperationMedicineItemType.pas',
  PrepareOperationNetItemListType in 'Rest\Types\PrepareOperationNetItemListType.pas',
  PrepareOperationNetItemType in 'Rest\Types\PrepareOperationNetItemType.pas',
  PrepareOperationScreenType in 'Rest\Types\PrepareOperationScreenType.pas',
  PrepareOperationType in 'Rest\Types\PrepareOperationType.pas',
  ProcessScreenType in 'Rest\Types\ProcessScreenType.pas',
  ProductType in 'Rest\Types\ProductType.pas',
  ResultSetRequestType in 'Rest\Types\ResultSetRequestType.pas',
  ResultSetResponseType in 'Rest\Types\ResultSetResponseType.pas',
  ResultType in 'Rest\Types\ResultType.pas',
  SpecialismListType in 'Rest\Types\SpecialismListType.pas',
  SpecialismType in 'Rest\Types\SpecialismType.pas',
  StatusType in 'Rest\Types\StatusType.pas',
  SupplierItemListType in 'Rest\Types\SupplierItemListType.pas',
  SupplierItemType in 'Rest\Types\SupplierItemType.pas',
  SupplierType in 'Rest\Types\SupplierType.pas',
  TemperatureListType in 'Rest\Types\TemperatureListType.pas',
  TemperatureType in 'Rest\Types\TemperatureType.pas',
  TermListType in 'Rest\Types\TermListType.pas',
  TermType in 'Rest\Types\TermType.pas',
  TitleType in 'Rest\Types\TitleType.pas',
  TranslationType in 'Rest\Types\TranslationType.pas',
  TypeListType in 'Rest\Types\TypeListType.pas',
  TypeType in 'Rest\Types\TypeType.pas',
  UserItemListType in 'Rest\Types\UserItemListType.pas',
  UserItemType in 'Rest\Types\UserItemType.pas',
  UserListScreenType in 'Rest\Types\UserListScreenType.pas',
  UserType in 'Rest\Types\UserType.pas',
  WeightScaleType in 'Rest\Types\WeightScaleType.pas',
  NetNumberGetResponse in 'Rest\Responses\NetNumberGetResponse.pas',
  BaseResponse in 'Rest\Responses\BaseResponse.pas',
  LocationItemListType in 'Rest\Types\LocationItemListType.pas',
  BaseRequest in 'Rest\Requests\BaseRequest.pas',
  ActiveBaseRequest in 'Rest\Requests\ActiveBaseRequest.pas',
  BaseResultSetRequest in 'Rest\Requests\BaseResultSetRequest.pas',
  LoginRequest in 'Rest\Requests\LoginRequest.pas',
  LoginResponse in 'Rest\Responses\LoginResponse.pas',
  TermListGetRequest in 'Rest\Requests\TermListGetRequest.pas',
  TermListGetResponse in 'Rest\Responses\TermListGetResponse.pas',
  Client in 'Rest\Client.pas',
  LanguageTermList in 'Units\LanguageTermList.pas',
  LanguageTerm in 'Units\LanguageTerm.pas',
  Utils in 'Units\Utils.pas',
  Config in 'Units\Config.pas',
  Splash in 'Forms\Splash.pas'{*.html},
  Login in 'Forms\Login.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TForm_Splash, Form_Splash);
  Application.CreateForm(TForm3, Form3);
  Application.Run;
end.
